import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ajvirus/Desktop/DTDB_Next/app/AnalyticsWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/Users/ajvirus/Desktop/DTDB_Next/app/globals.css");
;
import(/* webpackMode: "eager" */ "/Users/ajvirus/Desktop/DTDB_Next/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ajvirus/Desktop/DTDB_Next/src/components/layouts/DefaultLayout.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ajvirus/Desktop/DTDB_Next/src/components/ReduxProvider.tsx");
